// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YbRW","requiredAsterisk":"Info_requiredAsterisk__2eofv"};